<template>
    <div></div>
</template>

<script>
import request from "@/utils/request.js";
import qs from "qs";
import { navMixins } from "@/mixins.js";
export default {
    name: "WechatPreAuthorize",
    mixins: [navMixins],
    components: {
    },
    data() {
        return {};
    },
    created() {
        // 不能用vuex，因为刷新会导致状态机重置
        // 设置cookies为无限时长
        this.$cookies.set("App-Code", this.$route.query.state, -1);
        this.preAuth();
    },
    methods: {
        async preAuth() {
            const queryString = qs.stringify({
                ...this.$route.query
            });
            const result = await request.get(`/session/wechat/authorize?${queryString}`, {
                headers: {
                    "App-Code": this.$route.query.state
                },
                getResponse: true
            });
            const token = result.data.token;
            this.$cookies.set("App-Level", result.data.appLevel, -1);
            this.$cookies.set(`${this.$route.query.state}-token`, token, -1);
            this.onGoHome(result.data.appLevel);
        }
    }
}
</script>

<style lang="less"></style>